(ns practitest.frontend.testset2.select-instance-version-label
  (:require
   [ajax.core :as ajax]
   [clojure.string :as str]
   [day8.re-frame.http-fx]
   [practitest.frontend.common.i18n :refer [get-translation]]
   [practitest.frontend.components.modal :as modal]
   [practitest.frontend.components.notifications :as notifications]
   [practitest.frontend.components2.buttons :as buttons]
   [practitest.frontend.routing.backend-routes :as broutes]
   [practitest.frontend.subs :as subs]
   [practitest.frontend.testset2.events :as testset-events]
   [practitest.frontend.tests.version-label-common :as label-common]
   [re-frame.core :as re-frame]))

(def state-key :instance-select-label)

;; Events
(re-frame/reg-event-fx
  ::show-modal
  (label-common/show-modal-event state-key [::load-available-labels]))

(re-frame/reg-event-db
  ::hide-modal
  (fn [db _]
    (-> ((label-common/hide-modal-event state-key) db nil)
        (assoc-in [:form-states2 state-key :instance-ids] nil))))

(re-frame/reg-event-db
  ::set-skipped-tests
  (fn [db [_ skipped-tests]]
    (assoc-in db [:form-states2 state-key :skipped-tests] skipped-tests)))

(re-frame/reg-event-db
  ::hide-skip-message-modal
  (fn [db _]
    (assoc-in db [:form-states2 state-key :skipped-tests] nil)))

(re-frame/reg-event-db
  ::set-selected-label
  (label-common/set-selection-event state-key :selected-labels))

(re-frame/reg-event-fx
  ::load-available-labels
  (fn [{:keys [db]} [_ instance-ids]]
    {:db (-> db
             (update :progress conj ::load-available-labels)
             (assoc-in [:form-states2 state-key :instance-ids] instance-ids))
     :http-xhrio
     {:method          :get
      :uri             (broutes/get-url "instances#batch_available_version_labels"
                                        {:p_id (subs/get-current-project-id db)}
                                        {:instance_ids (str/join "," instance-ids)})
      :format          (ajax/json-request-format)
      :response-format (ajax/json-response-format {:keywords? true})
      :on-success      [::labels-loaded]
      :on-failure      [::labels-load-error]}}))

(re-frame/reg-event-fx
  ::labels-loaded
  (fn [{:keys [db]} [_ response]]
    (let [available-labels (:labels response)]
      {:db (-> db
               (assoc-in [:form-states2 state-key :available-labels] available-labels)
               (assoc-in [:form-states2 state-key :selected-labels] nil)
               (update :progress disj ::load-available-labels))})))

(re-frame/reg-event-fx
  ::labels-load-error
  (label-common/labels-load-error-event ::load-available-labels))

(re-frame/reg-event-fx
  ::apply-label
  (fn [{:keys [db]} [_ instance-ids selected-label]]
    (let [label-id (:id selected-label)]
      {:db (update db :progress conj ::apply-label)
       :http-xhrio
       {:method          :post
        :uri             (broutes/get-url "instances#batch_change_test_version" {:p_id (subs/get-current-project-id db)})
        :params          {:instance_ids instance-ids
                          :label_id label-id}
        :format          (ajax/json-request-format)
        :response-format (ajax/json-response-format {:keywords? true})
        :on-success      [::label-applied]
        :on-failure      [::label-apply-error]}})))

(re-frame/reg-event-fx
  ::label-applied
  (fn [{:keys [db]} [_ response]]
    (let [skipped-tests (:skipped_tests response)
          dispatches (cond-> [[::hide-modal]
                              [::notifications/success2
                               (get-translation "testset.instances.version-applied-success" "Version updated successfully")
                               {:auto-close true}]
                              [::testset-events/fetch-instances]]
                       (seq skipped-tests)
                       (conj [::set-skipped-tests skipped-tests]))]
      {:db (update db :progress disj ::apply-label)
       :dispatch-n dispatches})))

(re-frame/reg-event-fx
  ::label-apply-error
  (fn [{:keys [db]} [_ error]]
    (let [error-response (get-in error [:response])
          error-message (or (:error error-response)
                          (first (:errors error-response))
                          (get-translation "testset.instances.version-apply-error" "Error updating version"))]
      {:db (update db :progress disj ::apply-label)
       :dispatch [::notifications/error2 error-message {:auto-close true}]})))

;; Subscriptions
(re-frame/reg-sub ::show-modal? (label-common/show-modal-sub state-key))
(re-frame/reg-sub ::available-labels (label-common/available-labels-sub state-key))
(re-frame/reg-sub ::selected-label (label-common/selected-labels-sub state-key))

(re-frame/reg-sub
  ::instance-ids
  (fn [db]
    (get-in db [:form-states2 state-key :instance-ids])))

(re-frame/reg-sub
  ::skipped-tests
  (fn [db]
    (get-in db [:form-states2 state-key :skipped-tests])))

(defn skip-message-modal []
  (fn []
    (let [skipped-tests @(re-frame/subscribe [::skipped-tests])]
      [modal/bootstrap-modal
       {:is-open? (seq skipped-tests)
        :on-request-close #(re-frame/dispatch [::hide-skip-message-modal])
        :close-button? true
        :centered? true}

       [:div (get-translation "testset.instances.partial-update-title" "Partial Update")]

       [:div
        [:p (get-translation "testset.instances.skipped-tests-message.start"
                            "Update was done partially. The selected Label is not applicable to the following tests")
         ": "
         (interpose ", "
                    (for [test skipped-tests]
                      ^{:key (:id test)}
                      [:a {:href (:url test)
                           :target "_blank"}
                       (:display_id test)]))]
        [:p (get-translation "testset.instances.skipped-tests-message.end" "They remain unchanged.")]]

       [:div
        [buttons/button
         {:on-click #(re-frame/dispatch [::hide-skip-message-modal])
          :primary? true
          :text (get-translation "generic.button.ok" "OK")}]]])))

(defn select-instance-label-modal []
  (let [show? @(re-frame/subscribe [::show-modal?])
        available-labels @(re-frame/subscribe [::available-labels])
        selected-label @(re-frame/subscribe [::selected-label])
        instance-ids @(re-frame/subscribe [::instance-ids])]
    [label-common/version-label-modal
     {:title "test.versioning.modal.title"
      :title-default "Select a Version Label"
      :description "testset.instances.select-version-modal.description"
      :description-default "Select a version label to apply to the selected instances."
      :hide-modal-event [::hide-modal]
      :apply-event [::apply-label]
      :set-selection-event [::set-selected-label]
      :show? show?
      :available-labels available-labels
      :selected-labels selected-label
      :multi? false
      :placeholder (get-translation "testset.instances.select-version" "Select version")
      :can-create-labels? false
      :button-text "generic.button.apply"
      :button-text-default "Apply"
      :button-disabled? nil?
      :apply-args [instance-ids selected-label]}]))
